<template>
  <Layout>
    <div class="row app-coupon-detail">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>优惠券名称</label>
                  <input
                    v-model="item.title"
                    type="text"
                    class="form-control"
                    placeholder="请输入优惠券名称"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label>封面图片</label>
                  <image-upload ref="image"></image-upload>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>使用提示</label>
                  <input
                    v-model="item.notice"
                    type="text"
                    class="form-control"
                    placeholder="请输入使用提示"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>使用说明</label>
                  <b-form-textarea
                    v-model="item.description"
                    rows="3"
                    placeholder="请输入使用说明"
                  ></b-form-textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>客服电话</label>
                  <input
                    v-model="item.servicePhone"
                    type="text"
                    class="form-control"
                    placeholder="请输入客服电话"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="mb-3">
                  <label>优惠方案</label>
                  <div class="type-item">
                    <el-radio v-model="item.couponType" label="1">代金券</el-radio>
                    <div class="dsply-fix">
                      <input
                        v-model="item.reduceCost"
                        type="text"
                        class="form-control coupon-item-input"
                        placeholder="金额"
                      />
                      <span class="type-desc-text">元</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label style="opacity: 0">优惠方案</label>
                  <div class="type-item">
                    <el-radio v-model="item.couponType" label="2">折扣券</el-radio>
                    <div class="dsply-fix">
                      <input
                        v-model="item.discount"
                        type="text"
                        class="form-control coupon-item-input"
                        placeholder="百分比"
                      />
                      <span class="type-desc-text">%折扣</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label style="opacity: 0">优惠方案</label>
                  <div class="type-item">
                    <el-radio v-model="item.couponType" label="3">通用券</el-radio>
                    <input
                      v-model="item.text"
                      type="text"
                      class="form-control"
                      placeholder="请输入"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>库存数量</label>
                  <input
                    v-model="item.countNumber"
                    type="text"
                    class="form-control"
                    placeholder="请输入整数"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label>有效期</label>
                  <div>
                    <div class="dsply-fix mb-3">
                      <el-radio v-model="item.dateType" label="1">领取后</el-radio>
                      <input
                        style="width: 150px; margin: -0.65rem 5px 0 5px;"  
                        v-model="item.fixedTerm"
                        type="text"
                        class="form-control"
                        placeholder="请输入"
                      />
                      <span style="margin-top: -0.15rem;">天有效</span>
                    </div>
                    <div class="dsply-fix">
                      <el-radio v-model="item.dateType" label="0">固定有效期</el-radio>
                      <date-picker
                        style="width: 250px; margin: -0.65rem 5px 0 5px;"  
                        v-model="daterange"
                        type="datetime"
                        placeholder="开始时间 - 结束时间"
                        range
                        append-to-body
                        lang="en"
                        confirm
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>可领取会员等级</label>
                  <div class="dsply-fix">
                    <b-form-checkbox
                      v-for='(item, index) in levels' v-bind:key='index'
                      class="level-checkbox-item"
                      v-model="selectLevelItems" 
                      :value="item.level"
                      checked
                      plain
                    >{{item.name}}</b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>注册时长限制</label>
                  <div class="dsply-fix">
                    <span style="padding: 0.47rem 0.4rem;font-size: 0.8125rem;font-weight: 400;line-height: 1.5;">注册</span>
                    <input
                      v-model="item.regLimit"
                      type="text"
                      class="form-control"
                      placeholder="天数"
                      style="width: 100px;"
                    />
                    <span style="padding: 0.47rem 0.4rem;font-size: 0.8125rem;font-weight: 400;line-height: 1.5;">天内可以领取</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>领取数量限制</label>
                  <input
                    v-model="item.getLimit"
                    type="text"
                    class="form-control"
                    placeholder="请输入整数"
                  />
                </div>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>核销数量限制</label>
                  <input
                    v-model="item.useLimit"
                    type="text"
                    class="form-control"
                    placeholder="请输入整数"
                  />
                </div>
              </div>
            </div> -->

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>优惠券类型</label>
                  <div>
                    <el-radio class="radio-item" v-model="item.codeType" label="1">自有券</el-radio>
                    <el-radio class="radio-item" v-model="item.codeType" label="2">第三方券</el-radio>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-7">
                <div class="mb-3">
                  <label>状态</label>
                  <div>
                    <el-radio class="radio-item" v-model="item.status" label="1">上架</el-radio>
                    <el-radio class="radio-item" v-model="item.status" label="0">下架</el-radio>
                  </div>
                </div>
              </div>
            </div>

            <div class="row submit-bar">
              <div class="col-md-12">
                <!-- <div class="last-time pull-left">由 用户名 编辑于 2021-09-12 12:11:22</div> -->
                <div class="bar-handle">
                  <button @click="goBack()" class="btn-sm btn btn-outline-dark" type="button">取消</button>
                  <button @click="submitPreserve()" class="btn-sm btn btn-primary" type="button">保存</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </Layout>
</template>


<script>

import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../../layouts/main"
import imageUpload from "../../../../components/imageUpload"
import DatePicker from "vue2-datepicker";
import auth from '../../../../server/api/auth'
import conpon from '../../../../server/api/coupons'

export default {
  components: {
    Layout,
    DatePicker,
    imageUpload,
  },
  data() {
    return {
      item: {
        codeType: '1',
        status: '1'
      },
      daterange: '',
      index_id: '',
      shops: {},
      selectShopItems: [], //当前选择的店铺
      levels: [],
      selectLevelItems: [], // 当前选择的用户等级
      allModify: false,
    };
  },

  mounted() {
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
    }
    this.getLevels()
    if(this.$route.query.allModify){
      this.allModify = true
    }
  },

  methods: {

    getLevels(){
      auth.level().then(resp => {
        if (resp.code == 0) {
          this.levels = resp.data
          if(this.index_id){
            this.fetch()
          }
        }
      })
    },

    fetch(){
      var params = {
        id: this.index_id
      }; 
      conpon.detail(params).then(resp => {
        if (resp.code == 0) {
          this.item = resp.data
          if(this.item.merchantId){
            this.shops = {
              id: this.item.merchant.id,
              nickname: this.item.merchant.name
            }
          } 
          if(this.item.memberGrade){
            let gradeList = this.item.memberGrade.split(",");
            let that = this
            let currentGrade = []
            for (var i = 0; i < gradeList.length; i++) {
              let grade = gradeList[i]
              for (var j = 0; j < that.levels.length; j++) {
                let levelItem = that.levels[j]
                if(grade == levelItem.level){
                  currentGrade.push(grade)
                }
              }
            }
            that.selectLevelItems = currentGrade
          }
          if(this.item.reduceCost){
            this.item.reduceCost = Number(this.item.reduceCost) / 100
          }
          if(this.item.dateType == '0'){
            let daterange = []
            if(this.item.beginTimestamp){
              daterange.push(new Date(this.item.beginTimestamp * 1000))
            }
            if(this.item.endTimestamp){
              daterange.push(new Date(this.item.endTimestamp * 1000))
            }
            this.daterange = daterange
          }

          this.item.couponType = this.item.couponType.toString()
          this.item.dateType = this.item.dateType.toString()
          this.item.codeType = this.item.codeType.toString()
          this.item.status = this.item.status.toString()
          this.$refs.image.setImageUrl(this.item.image)
        }
      })
    },

    
    submitPreserve(){
      let params = JSON.parse(JSON.stringify(this.item));
      if(!params.title){
        Vue.swal("请输入优惠券名称");
        return
      }
      params.image = this.$refs.image.getImageUrl()
      if(!params.image){
        Vue.swal("请上传封面图片");
        return
      }
      if(params.couponType){
        // 代金券
        if(params.couponType == 1){
          params.leastCost = 0
          if(params.reduceCost){
            params.reduceCost = Number(params.reduceCost) * 100
          } else {
            Vue.swal("代金券优惠金额不能为空");
            return
          }
        }
        // 折扣券
        if(params.couponType == 2){
          if(!params.discount){
            Vue.swal("折扣券优惠百分比不能为空");
            return
          }
        }
        // 通用券
        if(params.couponType == 3){
          if(!params.text){
            Vue.swal("通用券描述不能为空");
            return
          }
        }
      } else {
        Vue.swal("请选择优惠方案");
        return
      }
      if(!params.countNumber){
        Vue.swal("请输入库存数量");
        return
      }
      if(params.dateType){
        // 领取后多少天
        if(params.dateType == '1'){
          if(!params.fixedTerm){
            Vue.swal("请输入有效天数");
            return
          }
        }
        // 固定有效期
        if(params.dateType == '0'){
          if(this.daterange.length){
            // params.beginTimestamp = this.daterange[0].format("yyyy-MM-dd hh:mm:ss");
            // params.endTimestamp = this.daterange[1].format("yyyy-MM-dd hh:mm:ss");
            params.beginTimestamp = this.daterange[0].getTime() / 1000;
            params.endTimestamp = this.daterange[1].getTime() / 1000;
          } else {
            Vue.swal("请选择有效时间");
            return
          }
        }
      } else {
        Vue.swal("请选择有效期类型");
        return
      }

      if(this.selectLevelItems.length){
        params.memberGrade = this.selectLevelItems.toString()
      } else {
        Vue.swal("请选择可领取会员等级");
        return
      }

      if(!params.getLimit){
        Vue.swal("请输入领取限制数量");
        return
      }
      // if(!params.useLimit){
      //   Vue.swal("请输入核销数量限制");
      //   return
      // }
      if(!params.codeType){
        Vue.swal("请选择优惠券类型");
        return
      }
      if(!params.status){
        Vue.swal("请选择状态");
        return
      }
      if(this.index_id){
        conpon.modify(params).then(resp => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "修改成功！",
              showConfirmButton: false,
              timer: 1000
            });
            this.goBack()
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
      } else {
        conpon.create(params).then(resp => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "创建成功！",
              showConfirmButton: false,
              timer: 1000
            });
            this.goBack()
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
      }
    },

    goBack(){
      this.$router.go(-1);
    }

  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .home-hot-detail .w-40bfz{
    width: 40%;
    float: left;
  }
  .home-hot-detail .w-60bfz{
    width: calc(60% - 10px)
  }

  .app-coupon-detail .type-item{
    border: 1px solid #ced4da;
    padding: 1.2rem 1rem;
  }

  .app-coupon-detail .type-item .coupon-item-input{
    width: calc(100% - 70px)
  }

  .app-coupon-detail .type-item .type-desc-text{
    width: 70px;
    padding: 0.47rem 0.75rem;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.5;
  }

  .app-coupon-detail .el-radio{
    margin-right: 0px;
  }

  .app-coupon-detail .level-checkbox-item{
    margin-right: 30px;
  }

  .app-coupon-detail .el-radio.radio-item{
    margin-right: 30px;
  }

  .select-current-media{
    display: inline-block;
    width: auto;
    padding: 0.47rem 0.75rem;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    position: relative;
    padding-left: 3.2rem;
  }

  .select-current-media img{
    width: 1.6rem;
    height: 1.6rem;
    position: absolute;
    left: 0.75rem;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

</style>

